import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonDirective } from '../../directives/button.directive';
import { ResizeDirective } from '../../directives/resize.directive';
import { SvgComponent } from '../svg/svg.component';

@Component({
  selector: 'app-button-menu-item',
  templateUrl: './button-menu-item.component.html',
  styleUrls: ['./button-menu-item.component.scss'],
  standalone: true,
  imports: [ButtonDirective, NgIf, SvgComponent, ResizeDirective, RouterLink, RouterLinkActive, NgTemplateOutlet],
})
export class ButtonMenuItemComponent {
  @Input() icon?: string;
  @Input() imageUrl?: string;
  @Input() customIcon?: string;
  @Input() imgLoading?: 'lazy' | 'eager' = 'eager';
  @Input() name?: string;
  @Input() location?: string;
  @Input() iconColor?: string;
  @Input() weight?: string;
  @Input() shape = 'small';
  @Input() height = '1';
  @Input() shortcut?: string;
  @Input() color = 'simple';
  @Input() buttonClass = '';
  @Input() disabled = false;
  @Input() fullWidth = false;
  @Input() routerLink: string[] | string;
  @Input() routerLinkActive: string;
  @Output() onClick = new EventEmitter();

  public sanitization = inject(DomSanitizer);
}
